import React, { Component } from "react";
import "./body.css";

class Body extends Component {
	constructor(props) {
		super(props);
		this.state = {name: this.props.name, code:this.props.code, desc:this.props.desc};
	}
	componentWillReceiveProps(nextProps) {
	    this.setState({ name: nextProps.name, code:nextProps.code, desc:nextProps.desc});
	}


	render() {
		return(
			<div className='wrapper'>
				<a href="https://github.com/tjkSec/Mathf"><h1 className="github">github</h1></a>
				<h1 className="codeHead"> <code>{ this.state.name }</code> </h1>
				<h1 className="descFont">{this.state.desc}</h1>
				<h1 className="codeBody">
					<pre>
						{ this.state.code }
					</pre>
				</h1>
			</div>
		);
	}
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/body/body.js